/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Reload_PageInputs */

const en_app_reload_page = /** @type {(inputs: App_Reload_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload page`)
};

const pt_br2_app_reload_page = /** @type {(inputs: App_Reload_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregar página`)
};

/**
* | output |
* | --- |
* | "Reload page" |
*
* @param {App_Reload_PageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const app_reload_page = /** @type {((inputs?: App_Reload_PageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Reload_PageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_reload_page(inputs)
	return pt_br2_app_reload_page(inputs)
});